<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Orders",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Orders",
            items: [
               {
                  text: "Orders",
                  href: "/staff",
               },  
               {
                  text: "Orders",
                  active: true,
               },                   
            ],

            orders: [],            
            
            pagination: {},
            
            keyword: "",
            listing_length: 10,
            status: '',
            token: "",
            errors: {},          
            active_page_url: null,
         };
      },
      mounted() {
    
      },

      methods: {
         
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">
                        <router-link :to="{ name: 'staffs' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <div class="row">
                     <div class="col-12">
                        <b-media class="mb-4">
                           <!-- <template v-slot:aside>
                              <img src="@/assets/images/users/avatar-2.jpg" alt class="avatar-md rounded-circle"/>
                              <br>
                           </template> -->
                           <b-media-body class="ms-3">
                              <h5 class="mt-1 mb-1">Zyed Ahmmad</h5>
                              <p>
                                 +91 1234567890
                              </p>
                           </b-media-body>
                        </b-media>
                     </div>
                  </div> 

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword"/>
                           </label>
                        </div>                     
                        <div class="listing-filter me-2">
                           <label>
                              <select class="form-control" v-model="status">    
                                 <option value="">All</option>        
                                 <option value="0">Pending</option>
                                 <option value="1">Completed</option>
                                 <option value="2">Cancelled</option>
                                 
                                 
                              </select>
                           </label>
                        </div>   
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th>Order ID</th>
                              <th>Product</th>
                              <th>Quantity</th>
                              <th>Total</th>
                              <th>Status</th>
                              <th>Options</th>
                           </tr>
                        </thead>
                        <tbody>
                           <tr>
                              <td>#12345</td> 
                              <td>Seer Fish</td> 
                              <td>2Kg</td> 
                              <td>500RS</td>
                              <td>
                                 <span class="badge rounded-pill bg-primary">Pending</span>
                              </td>
                              
                              <td>
                                 <router-link :to="{ name: 'orders.details' }" class="btn btn-primary me-2 mb-2 btn-sm">Order Details</router-link>
                              </td>
                           </tr>

                           <tr>
                              <td>#12345</td> 
                              <td>Black Pomfret</td> 
                              <td>0.5Kg</td> 
                              <td>600RS</td>
                              <td>
                                 <span class="badge rounded-pill bg-success">Completed</span>
                              </td>
                              
                              <td>
                                 <router-link :to="{ name: 'orders.details' }" class="btn btn-primary me-2 mb-2 btn-sm">Order Details</router-link>
                              </td>
                           </tr>

                           <tr>
                              <td>#12345</td> 
                              <td>Seer Fish</td> 
                              <td>2Kg</td> 
                              <td>500RS</td>
                              <td>
                                 <span class="badge rounded-pill bg-danger">Cancelled</span>
                                 <p>Refund: Yes</p>
                              </td>
                              
                              <td>
                                 <router-link :to="{ name: 'orders.details' }" class="btn btn-primary me-2 mb-2 btn-sm">Order Details</router-link>
                              </td>
                           </tr>

                 
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->
 <!----pagination starts --->     
                  <caption class="float-start mt-4 d-block d-lg-inline">Showing 1 to 10 of 26 entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item disabled">
                        <a href="#" class="page-link">
                           <i class="mdi mdi-chevron-left"></i>
                        </a>
                     </li>
                     <li class="page-item">
                        <a href="#" class="page-link">1</a>
                     </li>
                     <li class="page-item active">
                        <a href="#" class="page-link">2</a>
                     </li>
                     <li class="page-item">
                        <a href="#" class="page-link">3</a>
                     </li>
                     
                     <li class="page-item">
                        <a href="#" class="page-link">
                           <i class="mdi mdi-chevron-right"></i>
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->


               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
